import { Flex } from '@zillow/constellation';
import { Card, Image, Paragraph, Text } from '@zillow/constellation-10';

import { VERTICAL_DISPLAY_TYPE } from '../../../../constants/PropertiesConstants';
import SvgTreeline from '../../../../images/treeline-illustration.svg';
import { StyledIconChevronRightCircle } from './StyledComponents';
import SimpleCard from '../../../SimpleCard';

import type { ApplicationsSummary } from '../../interfaces';

type Props = {
  displayType?: VERTICAL_DISPLAY_TYPE;
  updateMinModuleHeight?: () => void;
  applicationsSummary: ApplicationsSummary;
};

const ApplicationsSummaryCard = ({ applicationsSummary, displayType = VERTICAL_DISPLAY_TYPE.FULL }: Props) => {
  if (!applicationsSummary) {
    return null;
  }

  const {
    urlPath,
    remainingSummaryCount: { remainingCount, remainingCountNew },
  } = applicationsSummary;

  const marginBottomMediaQuery = displayType === VERTICAL_DISPLAY_TYPE.SIMPLE ? 0 : { base: '600', lg: 0, xl: '600' };

  const handleCardClick = () => {
    window.router.updateLocation(urlPath);
  };

  const cardContent = (
    <>
      <Paragraph
        css={{ textStyle: { base: 'body-sm-bold', lg: 'body-bold' } }}
      >{`+ ${remainingCount} applications...`}</Paragraph>
      {remainingCountNew > 0 ? (
        <Paragraph textStyle="body-sm" css={{ marginTop: '200', marginBottom: marginBottomMediaQuery }}>
          Includes
          <Text textStyle="body-sm-bold" css={{ color: 'text.feedback.warning.hero' }}>
            {` ${remainingCountNew} new `}
          </Text>
          applications.
        </Paragraph>
      ) : (
        <Paragraph textStyle="body-sm" css={{ marginTop: '200', marginBottom: marginBottomMediaQuery }}>
          You&apos;ve reviewed them all
        </Paragraph>
      )}

      {displayType === VERTICAL_DISPLAY_TYPE.FULL && (
        <Flex display={{ default: 'none', xl: 'flex' }}>
          <Image src={SvgTreeline} alt="background" css={{ position: 'relative', bottom: '10px', height: '35px' }} />
          <StyledIconChevronRightCircle size="sm" />
        </Flex>
      )}
    </>
  );

  if (displayType === VERTICAL_DISPLAY_TYPE.SIMPLE) {
    return (
      <SimpleCard withChevron cursor="pointer" onClick={handleCardClick}>
        {cardContent}
      </SimpleCard>
    );
  }

  return (
    <Card.Root tone="neutral" elevated={false} css={{ height: '150px', cursor: 'pointer', padding: 'none' }}>
      <Card.Body onClick={handleCardClick} css={{ padding: 'Card.Root.padding' }}>
        {cardContent}
      </Card.Body>
    </Card.Root>
  );
};

export default ApplicationsSummaryCard;
